import React from 'react';

// ─── SHARED FORM BLOCK WRAPPER ────────────────────────────────────────────────
function FBWrap({ comp, children }) {
  return (
    <div style={{
      width: '100%', height: '100%', overflow: 'hidden', boxSizing: 'border-box',
      display: 'flex', flexDirection: 'column', justifyContent: 'center',
      gap: comp.gap || 6,
    }}>
      {comp.showLabel !== false && (
        <label style={{
          fontSize: comp.labelFontSize || 13, fontWeight: comp.labelFontWeight || 500,
          color: comp.labelColor || '#111827',
          display: 'flex', alignItems: 'center', gap: 4,
        }}>
          {comp.labelText || 'Label'}
          {comp.isMandatory && <span style={{ color: '#DC2626', fontSize: 10 }}>*</span>}
        </label>
      )}
      {children}
      {comp.helpText && (
        <div style={{ fontSize: 11, color: '#9CA3AF' }}>{comp.helpText}</div>
      )}
    </div>
  );
}

function inputBoxStyle(comp) {
  return {
    padding: `${comp.inputPaddingV ?? 10}px ${comp.inputPaddingH ?? 12}px`,
    border: `${comp.inputBorderWidth || 1}px ${comp.inputBorderStyle || 'solid'} ${comp.inputBorderColor || '#CDD0D8'}`,
    borderRadius: comp.inputBorderRadius || 7,
    fontSize: comp.inputFontSize || 14,
    color: comp.placeholderColor || '#9CA3AF',
    background: comp.inputBg || '#fff',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    width: '100%', boxSizing: 'border-box',
  };
}

// ─── INPUT FIELD ──────────────────────────────────────────────────────────────
export function InputField({ comp }) {
  return (
    <FBWrap comp={comp}>
      <div style={inputBoxStyle(comp)}>{comp.placeholder || 'Enter value…'}</div>
    </FBWrap>
  );
}

// ─── DROPDOWN ────────────────────────────────────────────────────────────────
export function Dropdown({ comp }) {
  return (
    <FBWrap comp={comp}>
      <div style={inputBoxStyle(comp)}>
        <span>{comp.placeholder || 'Select…'}</span>
        <span style={{ fontSize: 12 }}>⌄</span>
      </div>
    </FBWrap>
  );
}

// ─── DATE PICKER ─────────────────────────────────────────────────────────────
export function DatePicker({ comp }) {
  const label =
    comp.dateType === 'month' ? 'MM / YYYY' :
    comp.dateType === 'year'  ? 'YYYY' : 'DD / MM / YYYY';

  return (
    <FBWrap comp={comp}>
      <div style={inputBoxStyle(comp)}>
        <span>{label}</span>
        <span>▦</span>
      </div>
    </FBWrap>
  );
}

// ─── TEXT AREA ───────────────────────────────────────────────────────────────
export function TextArea({ comp }) {
  return (
    <FBWrap comp={comp}>
      <div style={{
        ...inputBoxStyle(comp),
        alignItems: 'flex-start',
        minHeight: (comp.rows || 4) * 22,
      }}>
        {comp.placeholder || 'Enter text…'}
      </div>
    </FBWrap>
  );
}

// ─── FILE UPLOAD ─────────────────────────────────────────────────────────────
export function FileUpload({ comp }) {
  return (
    <FBWrap comp={comp}>
      <div style={{ ...inputBoxStyle(comp), borderStyle: 'dashed' }}>
        <span>↑</span>
        <span>Choose file…</span>
      </div>
    </FBWrap>
  );
}

// ─── SEARCH BAR ──────────────────────────────────────────────────────────────
export function SearchBar({ comp }) {
  return (
    <div style={{
      width: '100%', height: '100%', overflow: 'hidden', boxSizing: 'border-box',
      display: 'flex', alignItems: 'center', gap: 9,
      padding: `${comp.padV ?? 10}px ${comp.padH ?? 14}px`,
      background: comp.bg || '#fff',
      border: `${comp.borderWidth || 1}px ${comp.borderStyle || 'solid'} ${comp.borderColor || '#CDD0D8'}`,
      borderRadius: comp.borderRadius || 8,
    }}>
      <span style={{ fontSize: comp.fontSize || 14, color: comp.iconColor || '#9CA3AF' }}>⌕</span>
      <span style={{ fontSize: comp.fontSize || 14, color: comp.textColor || '#9CA3AF' }}>
        {comp.placeholder || 'Search…'}
      </span>
    </div>
  );
}
